import axios from 'axios';
import {
  TariffExplanationRequest,
  TariffExplanationResponse,
  ECCNRequest,
} from 'interfaces/AIEvalInterfaces';
import KeycloakService from 'services/KeycloakService';

export const runAIExplanationOnly = async (
  request: TariffExplanationRequest,
): Promise<TariffExplanationResponse | null> => {
  const URL = `${process.env.REACT_APP_PYAPI_URL}/calc_tariffs`;
  return axios
    .post(URL, request, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${KeycloakService.getToken()}`,
      },
      timeout: 120000,
    })
    .then((res) => {
      const { data } = res as { data: TariffExplanationResponse };
      return data;
    })
    .catch((error) => {
      console.error(`[AI] Error evaluating threat level: ${error.message}`);
      const data: TariffExplanationResponse = {
        explanation: '',
      };
      return data;
    });
};

export const crossRulings = async (request: {
  hts_code: string;
  product_description: string;
}): Promise<{ cross_data_links: any[] } | null> => {
  const URL = `${process.env.REACT_APP_PYAPI_URL}/cross-rulings`;
  return axios
    .post(URL, request, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${KeycloakService.getToken()}`,
      },
      timeout: 120000,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      console.error(`[AI] Error evaluating threat level: ${error.message}`);
      const data: { cross_data_links: any[] } = {
        cross_data_links: [],
      };
      return data;
    });
};

export const ECCNcheck = async (
  request: ECCNRequest,
  onChunk?: (chunk: any) => void, // optional callback for streaming chunks
): Promise<void> => {
  // CHANGE URL to the stream endpoint
  const URL = `${process.env.REACT_APP_PYAPI_URL}/evaluate_eccn_control_stream`;

  const response = await fetch(URL, {
    method: 'POST',
    headers: {
      // ADD x-ndjson to Accept so intermediaries don’t buffer it
      Accept: 'application/x-ndjson, application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${KeycloakService.getToken()}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.body) {
    throw new Error('No response body');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    if (done) {
      break;
    }

    buffer = buffer + decoder.decode(value, { stream: true });

    let boundary = buffer.indexOf('\n');
    while (boundary !== -1) {
      const chunk = buffer.slice(0, boundary).trim();
      buffer = buffer.slice(boundary + 1);

      if (chunk) {
        try {
          const parsed = JSON.parse(chunk);
          onChunk?.(parsed); // stream callback
        } catch (e) {
          console.error('Failed to parse chunk', e, chunk);
        }
      }
      boundary = buffer.indexOf('\n');
    }
  }
};
